import { render } from "./AddHouse.vue?vue&type=template&id=7e3460a8"
import script from "./AddHouse.vue?vue&type=script&lang=js"
export * from "./AddHouse.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__